import DiscoverAlbumFolderPrepaidItems from './DiscoverAlbumFolderPrepaidItems';

export default DiscoverAlbumFolderPrepaidItems;
